/** A one-time request to open existing report controls, never saved filter state. */
export const REPORT_ACTION_PARAM = 'reportAction';
export type ReportAction = 'saved-views' | 'schedules';

export function readReportAction(search: string): ReportAction | null {
  const values = new URLSearchParams(search).getAll(REPORT_ACTION_PARAM);
  return values.length === 1 && (values[0] === 'saved-views' || values[0] === 'schedules') ? values[0] : null;
}

export function reportActionHref(href: string, action: ReportAction): string {
  const url = new URL(href, window.location.origin);
  if (url.origin !== window.location.origin) {
    throw new Error('Open report controls on this Admin site.');
  }
  url.searchParams.set(REPORT_ACTION_PARAM, action);
  return `${url.pathname}${url.search}${url.hash}`;
}
